<template>
  <div class="console_body">
    <div class="console_log">
      <!-- 头部登陆 -->
      <div class="console_log_icon"></div>
      <div class="console_log_right console_log_online" v-if="username">
        <!-- 已登录 -->
        <p>欢迎您，{{username}}</p>
        <el-button round @click="quit">退出系统</el-button>
      </div>
      <div class="console_log_right console_log_offline" v-else>
        <!-- 未登录 -->
        <p @click="showLoginModel = true">登录</p>
      </div>
    </div>
    <div class="console_title">
      <!-- 标题 -->
      <div class="console_title_online" v-if="username">
        <img src="./assets/sanhe_main_tit.png" >
        <p>Sanhe intelligent platform for human settlements improvement</p>
      </div>
      <div class="console_title_offline" v-else>
        <img src="./assets/sanhe_main_tit2.png" >
        <p>Intelligent platform for human settlements improvement</p>
      </div>
    </div>
    <div class="concole_product">
      <!-- 产品列表 -->
      <div class="concole_product_item" v-for="(item, index) in menu" :key="index" @click="handleItemClick(item)">
        <div class="concole_product_item_icon">
          <img :src="item.icon" >
        </div>
        <p class="concole_product_item_name">{{item.name}}</p>
      </div>
    </div>

    <el-dialog
      class="login_model"
      :visible.sync="showLoginModel"
      width="30%"
      center
    >
      <!-- 登录弹窗 -->
      <el-row class="login-info" >
        <el-col :span="24" style="margin-bottom: 30px; font-size: 20px; text-align: center">
          <b>登录</b>
        </el-col>
        <el-col :span="24">
          <el-input
            class="login-input"
            placeholder="请输入邮箱"
            maxlength="16"
            prefix-icon="el-icon-user"
            v-model="account"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-input
            class="login-input"
            show-password
            placeholder="请输入密码"
            maxlength="16"
            prefix-icon="el-icon-lock"
            v-model="password"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-input
            class="login-input"
            placeholder="请输入验证码"
            v-model="captcha"
            prefix-icon="el-icon-chat-line-square"
          >
            <template slot="append">
              <img class="getCaptcha" :src="codesrc" @click="getImgCode" />
            </template>
          </el-input>
        </el-col>
        <el-col :span="24">
          <el-button
            class="login_btn"
            type="primary"
            :disabled="checked"
            @click="loginClick"
          >登录</el-button >
        </el-col>
      </el-row>
    </el-dialog>

  </div>
    
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { getUserInfo, getRecord, addRecord } from '@/api/console'
export default {
  name: 'ProductConsoleRJ',
  data() {
    return {
      showLoginModel: false,
      menu: [
        {name:'综合指挥中心', icon: require('./assets/icon_main_01.png'), url: window.location.origin + '/ScreenDisplayRJ'},
        {name:'厕所革命', icon: require('./assets/icon_main_02.png'), url:'http://cg.eiiplat.com/#/login'},
        {name:'垃圾治理', icon: require('./assets/icon_main_03.png'), url:'http://is.eiiplat.com/#/login'},
        {name:'污水治理', icon: require('./assets/icon_main_04.png'), url:'none'},
        {name:'村容村貌', icon: require('./assets/icon_main_05.png'), url:'none'},
      ],
      codesrc: null,
      randomStr: null,
      account: "",
      password: "",
      captcha: "",
      checked: false,
    }
  },
  created() {
    this.getImgCode();
  },
  computed: {
    username() {
      return this.$store.state.user.userName
    }
  },
  methods: {
    ...mapMutations([
      'SET_NAME', //将mutation里的方法映射到该组件内
        //等同于this.$store.commit('DECREASE_SHOPCART')
    ]),
    ...mapActions({
      quit:'logout'
    }),
    handelLogin(){
      // 点击表单登陆
    },
    handleItemClick(item) {
      if(this.username){
        if(item.url === 'none') {
          // 提示没有权限
          this.$message({
            message: '抱歉！您暂未拥有此版块权限',
            type: 'warning'
          });
        }else if(item.url.indexOf('login') != -1) {
          // 厕改和管控
          window.open(`${item.url}?token=${localStorage.usertoken}`)
        }else{
          // 大屏展示
          window.open(`${item.url}`)
        }
      }
      else{
        this.showLoginModel = true;
      }
    },
    async getImgCode() {
      this.$axios({
        url: "/api/code",
        method: "get",
        responseType: "blob",
      }).then((res) => {
        const raw = res.data;
        const { randomstr } = res.headers;
        this.randomStr = randomstr;
        this.codesrc = window.URL.createObjectURL(raw);
      });
    },
    loginClick() {
      var params = {
        username: this.account,
        password: this.password,
        captcha: this.captcha,
        randomStr: this.randomStr,
      };

      var that = this;
      this.$axios({
        url: "/api/auth/login",
        method: "post",
        data: params,
      }).then((res) => {
        if (res.data.code === 0) {
          this.$message.success("登录成功");
          this.usertoken = res.data.token;
          this.userId = res.data.userId;
          localStorage.setItem("userName", this.account);
          localStorage.setItem("usertoken", res.data.token);
          localStorage.setItem("userId", res.data.userId);
          that.SET_NAME(that.account);
          this.showLoginModel = false;
          // this.$axios({
          //   url: "/api/pt/tenant/getMyTenantInfo",
          //   method: "post",
          //   headers: {'token': this.usertoken}
          // })
          //   .then((res) => {
          //     localStorage.setItem("userType", res.data.code);
          //     location.href = "/";
          //   })
        } else {
          this.$message.error(res.data.msg);
        }
      })
      .catch((error) => {
        console.log("error", error);
        this.$message.error("登录错误，请重试！");
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .console_body{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url(./assets/bg_Main-system.png) ;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: auto;
    .console_log{
      position: absolute;
      right: 0;
      top: 0;
      height: 48px;
      margin: 30px;
      display: flex;
      .console_log_icon{
        width: 28px;
        height: 28px;
        margin: 10px 18px;
        background-image: url(./assets/icon_default-avatar.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .console_log_right{
        height: 48px;
        display: flex;
        color: #fff;
        >p{
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 22px;
        }
        .el-button{
          color: #fff;
          background: rgba(255, 255, 255, 0);
          border: 1px solid #FFFFFF;
          border-radius: 40px 40px 40px 40px;
          margin-left: 18px;
        }
      }
      .console_log_offline{
        >p{
          cursor: pointer;
        }
      }
    }
    .console_title{
      position: absolute;
      top: 261px;
      left: 50%;
      margin-left: -500px;
      height: 130px;
      width: 1000px;
      .console_title_online, .console_title_offline{
        height: 130px;
        width: 1000px;
        display: flex;
        flex-direction: column;
        align-items: center;
        >img{
          height: 86px;
        }
        >p{
          height: 35px;
          font-size: 25px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 29px;
        }
      }
      

    }
    .concole_product{
      width: 1200px;
      height: 400px;
      position: absolute;
      top: 471px;
      left: 50%;
      margin-left: -600px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .concole_product_item{
        width: 218px;
        height: 235px;
        transition: all 0.1s linear;
        padding: 64px 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .concole_product_item_icon{
          width: 120px;
          height: 120px;
          transition: all 0.1s linear;
          >img{
            width: 100%;
            height: 100%;
          }
        }
        .concole_product_item_name{
          height: 34px;
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
          transition: all 0.1s linear;
        }
      }
      .concole_product_item:hover{
        width: 250px;
        height: 272px;
        .concole_product_item_icon, 
        .concole_product_item_name{
          transform:scale(1.15);
        }
        
      }
    }
  }
  .login-info {
    width: 100%;
    background-color: #fff;
    box-shadow: none;
    border-radius: 10px;
    padding: 0px 40px 20px;
    
    b{
      font-size: 28px;
      font-weight: 500;
      color: #000000;
    }
  }
  .getCaptcha {
    display: block;
    width: 100px;
    height: 35px;
  }

  .foot-end {
    font-size: 12px;
    margin-top: 30px;
    padding-top: 10px;
    text-align: center;
    color: #939393;
    position: fixed;
    bottom: 0;
    margin: 0 auto;
    width: 100%;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .login-input {
    margin-bottom: 30px;
  }
  .link {
    text-decoration: underline;
    color: #409eff;
  }
  .reg-text {
    font-size: 12px;
    text-align: right;
    width: 95%;
    margin-top: 10px;
  }
  .login_btn{
    width: 100%; 
    background: #3894FF;
    box-shadow: 0px 5px 12px 1px rgba(56, 148, 255, 0.1);
    border-radius: 10px 10px 10px 10px;
    border-color: #3894FF;
  }
  .font-12 {
    font-size: 12px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }

  
</style>
<style lang="scss" >
  .login_model{
    >div{
      min-width: 400px;
      border-radius: 10px 10px 10px 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ProductDetails/ProductConsoleRJ.vue